import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Moment } from 'moment/moment';
import { momentToNgbDate, ngbDateToMoment } from '../utility';


/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class MomentNgbDateAdapter extends NgbDateAdapter<Moment> {
  fromModel = (date: Moment | null): NgbDateStruct | null => date ? momentToNgbDate(date) : null;
  toModel = (date: NgbDateStruct | null): Moment | null => date ? ngbDateToMoment(date) : null;
}
